import './Milestone.css';
import React from "react";

function Milestone(props) {

    return (
        <div className="milestoneDiv">
            <p className="individualMilestoneHeaderText"> {"milestone #" + (props.index + 1)}</p>
            <div className="milestoneIndividual">
                <p className="milestoneIndividualNameText">{props.milestone}</p>
            </div>
        </div>
    )
}

export default Milestone;